'use strict';

function PerformanceReviewAgreementLockController(performanceReviewService, $modal, $q) {
  var vm = this;

  vm.$onInit = $onInit;

  vm.claimAgreementTurn = claimAgreementTurn;
  vm.openConfirmAgreementTurnModal = openConfirmAgreementTurnModal;

  function $onInit() {
    vm.active = false;
    vm.isLocked = !(!!vm.isLocked);
    vm.onLock = vm.onLock();
  }

  function openConfirmAgreementTurnModal() {
    vm.confirmAgreementTurnModal = $modal({
      template: require('./performance-review-agreement-lock-confirm.modal.html'),
      show: true
    });
    vm.confirmAgreementTurnModal.$scope.submit = claimAgreementTurn;
  }

  function claimAgreementTurn() {
    vm.active = true;

    return performanceReviewService.retrieve.agreement.agreementTurn(vm.token)
      .then(claimAgreementTurnOk)
      .catch(claimAgreementTurnFailed)
      .finally(function () {
        vm.active = false;
        vm.confirmAgreementTurnModal.$scope.$hide();
      });
  }

  function claimAgreementTurnOk(response) {
    return vm.onLock($q.resolve(response));
  }

  function claimAgreementTurnFailed(response) {
    return $modal({
      template: require('./performance-review-agreement-lock.modal.html'),
      show: true,
      onHide: function reject() {
        return vm.onLock($q.reject(response));
      }
    });
  }
}

module.exports = PerformanceReviewAgreementLockController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-agreement-lock/performance-review-agreement-lock.controller.js
 ** module id = 261
 ** module chunks = 0
 **/